export const spreadsheetsJA = {
  "There no individual spreadsheets to display": "There no individual spreadsheets to display",
  "New Spreadsheet": "New Spreadsheet",
  "Actions": "Actions",
  "Format Name": "Format Name",
  "Description": "Description",
  "Folder": "Folder",
  "Modified By": "Modified By",
  "Date Modified": "Date Modified",
  "Created By": "Created By",
  "Date Created": "Date Created",
  "Run Spreadsheet": "Run Spreadsheet",
  "Edit Spreadsheet": "Edit Spreadsheet",
  "Delete Spreadsheet": "Delete Spreadsheet",
  "Are you sure you want to delete the selected format?": "Are you sure you want to delete the selected format?",
  'Delete Format': 'Delete Format',
  'Cancel': 'Cancel',
  'Query (Optional)': 'Query (Optional)',
  'Sort (Optional)': 'Sort (Optional)',
  'Columns': 'Columns',
  'Are you sure you wish to remove all fields?': 'Are you sure you wish to remove all fields?',
  'Are you sure you wish to remove all sort fields?': 'Are you sure you wish to remove all sort fields?',
  'Direction': 'Direction',
  'Ascending': 'Ascending',
  'Descending': 'Descending',
  'Failed to save formats': 'Failed to save formats',
  'This field is required': 'この項目は必須です',
  'Missing required data for upload. Please ensure all required fields are available.': 'アップロードに必要なデータが不足しています。必須項目がすべて利用可能であることを確認してください。',
  'Information Message': '情報メッセージ',
  'Number field accepts numeric values only, please re-try.': '数値フィールドには数値のみ入力できます。再度お試しください。',
  'Invalid number': '無効な数値です',
  'Upload Error': 'アップロードエラー',
  'Confirmation message': '確認メッセージ',
  'Upload Success': 'アップロード成功',
  'Overwrite failed': '上書きに失敗しました',
  'Overwrite': '上書き',
  'File upload failed. Please try again.': 'ファイルのアップロードに失敗しました。再度お試しください。',
  'File type not allowed: {fileName}': '許可されていないファイル形式です: {fileName}',
  'File "{fileName}" already exists. Overwrite?': 'ファイル "{fileName}" は既に存在します。上書きしますか？',
  'File "{fileName}" uploaded successfully.': 'ファイル "{fileName}" のアップロードに成功しました。',
  'Browse to {value}': '{value} を参照',
  'Open': '開く',
  'Download': 'ダウンロード',
  'Click to view full image for {value}': '{value} の画像全体を表示するにはクリックしてください',
  'Upload Image': '画像をアップロード',
  'Upload Document': 'ドキュメントをアップロード',
  'Yes (Y)': 'はい (Y)',
  'No (N)': 'いいえ (N)',
};